import React from 'react'

import { tokens } from '@news-mono/design-tokens'
import { useAuthActions } from '../../../authentication'
import {
    BodyText,
    Heading,
    StyledCTAWardenButton,
    StyledTextLink,
    TextWrapper,
} from './component.styled'

type LoginContentProps = {
    text: CTAText
}

export const LoginContent = ({ text }: LoginContentProps) => {
    const { onRegisterClick, onLoginClick } = useAuthActions()

    return (
        <>
            <TextWrapper>
                <Heading>{text.title}</Heading>
                <BodyText>{text.body}</BodyText>
            </TextWrapper>

            <StyledCTAWardenButton
                onClick={onRegisterClick}
                backgroundColors={{
                    default:
                        tokens.thenightly.colors.palette.utility.error.default,
                    hover: tokens.thenightly.colors.palette.utility.error.hover,
                }}
                roundEdges={true}
                useWidePadding={true}
            >
                CREATE FREE ACCOUNT
            </StyledCTAWardenButton>

            <BodyText>
                Already have an account?
                <StyledTextLink onClick={onLoginClick}>
                    Log in here
                </StyledTextLink>
            </BodyText>
        </>
    )
}
